export default {
  updateId ({ commit }, data) {
    commit('UPDATE_FIELD', { field: 'id', message: data })
  },
  updateContent ({ commit }, data) {
    commit('UPDATE_FIELD', { field: 'content', message: data })
  },
  updateResourceId ({ commit }, data) {
    commit('UPDATE_FIELD', { field: 'resource_id', message: data })
  },
  updateResourceType ({ commit }, data) {
    commit('UPDATE_FIELD', { field: 'resource_type', message: data })
  },
  initModel ({ commit }) {
    commit('UNSET_ACTIVE_RECOMMENDATION')
  },
  fillModel ({ commit }, data) {
    commit('SET_ACTIVE_RECOMMENDATION', data)
  },
  fetchRecommendations ({ commit }) {
    this._vm.$network_utils.getServiceRecommendations()
      .then(response => {
        commit('SET_RECOMMENDATIONS', response)
      }).catch(error => {
        console.error(error)
      })
  },
  fetchRecommendation ({ commit }, data) {
    this._vm.$network_utils.getServiceRecommendation(data)
      .then(response => {
        const payload = { ...{ content: '' }, ...data, ...response }
        commit('SET_ACTIVE_RECOMMENDATION', payload)
      }).catch(error => {
        console.error(error)
      })
  },
  createRecommendation ({ state, commit }) {
    commit('SET_IS_SUBMITTING', true)
    this._vm.$network_utils.postServiceRecommendation(state.active_recommendation)
      .then(response => {
        commit('SET_ACTIVE_RECOMMENDATION', response)
        commit('SET_IS_SUBMITTING', false)
      }).catch(error => {
        console.log(error)
      })
  },
  updateRecommendation ({ state, commit }) {
    commit('SET_IS_SUBMITTING', true)
    this._vm.$network_utils.updateServiceRecommendation(state.active_recommendation)
      .then(response => {
        commit('SET_IS_SUBMITTING', false)
      }).catch(error => {
        console.log(error)
      })
  },
  deleteRecommendation ({ state, commit }) {
    commit('SET_IS_DELETING', true)
    this._vm.$network_utils.deleteServiceRecommendation({
      id: state.active_recommendation.id
    })
      .then(() => {
        commit('UNSET_ACTIVE_RECOMMENDATION')
        commit('SET_IS_DELETING', false)
      }).catch(error => {
        console.error(error)
      })
  }
}
